module.exports = __webpack_public_path__ + "static/media/yellowTheme-girl.884ed94f.svg";